export default __webpack_public_path__ + "static/media/5.f102b3da.svg";